import { useState } from "react";
import { NavLink } from "react-router-dom";
import style from "./NavStyle.module.css";
import logo from "../../assets/logo.png";
import ThemeToggle from "../ThemeToggle";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const linkClass = ({ isActive }) =>
    isActive ? `${style.navLink} ${style.active}` : style.navLink;

  return (
    <nav className={style.navbar}>
      <NavLink to="/" className={style.logo}>
        <img src={logo} alt="Vyra Pharma" className={style.logoimg} />
      </NavLink>

      <div className={style.navRight}>
        <ThemeToggle />

        <button
          className={`${style.hamburger} ${menuOpen ? style.hamburgerOpen : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle navigation"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      <div className={`${style.nav_links} ${menuOpen ? style.navOpen : ""}`}>
        <NavLink to="/" className={linkClass} onClick={() => setMenuOpen(false)} end>Home</NavLink>
        <NavLink to="/products" className={linkClass} onClick={() => setMenuOpen(false)}>Products</NavLink>
        <NavLink to="/about" className={linkClass} onClick={() => setMenuOpen(false)}>About Us</NavLink>
        <NavLink to="/contact" className={linkClass} onClick={() => setMenuOpen(false)}>Contact Us</NavLink>
        <NavLink to="/login" className={linkClass} onClick={() => setMenuOpen(false)}>Login</NavLink>
      </div>
    </nav>
  );
}

export default Navbar;
